
import { Box, Text } from "@chakra-ui/react"
import { Alert } from "./ui/alert"
import { useAuth0 } from "@auth0/auth0-react"
import { useAuthorizedRequest } from "@/hooks/useRequest"
import { t } from "@/lib/i18n"

function jsonFetcher(url: string, token: string) {
    return fetch(url, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json());
}

export const Me: React.FC = () => {
    let { isAuthenticated, user } = useAuth0()

    const { data, error } = useAuthorizedRequest<{ permissions: string[] }>('/me', jsonFetcher)

    if (error && !data) {
        return <Alert status="error" title={error.message} />
    }

    const permissions = data?.permissions

    return (
        <Box>
            {isAuthenticated && user && (
                <Box>
                    <Text fontSize="2xl" mb={4}>{t('profile.your_profile')}</Text>
                    <Text>{t('profile.name')}: {user?.name}</Text>
                    <Text>{t('profile.email')}: {user?.email}</Text>
                </Box>
            )
            }
            <Text fontSize="2xl" mb={4}>{t('profile.your_permissions')}:</Text>
            {
                permissions?.length && (
                    permissions.map((role) => <Text key={role}>{role}</Text>)
                )
            }
        </Box >
    )
}
